import { LoanData, LoanDetailsData, AutopayDetails } from '@/interfaces/loan';

export function setAutopayValue(state: LoanData, value: boolean) {
  state.data.recurring_payments = value;
}

export function setLoanData(state: LoanData, loanDetails: LoanDetailsData) {
  state.data = loanDetails;
}

export function setAutopayDetails(
  state: LoanData,
  value: AutopayDetails | null
) {
  state.autopayDetail = value;
}
